import { Capacitor } from "@capacitor/core";
import { ReactElement } from "react";

export default function MobileBottomNavWrapper({
  children,
}: {
  children: ReactElement;
}): JSX.Element {
  return (
    <div
      className="flex items-center justify-between pt-2 px-8 text-xs sm:text-sm"
      style={{
        paddingBottom: Capacitor.isNativePlatform()
          ? Capacitor.isPluginAvailable("SafeArea")
            ? "var(--safe-area-inset-bottom, 20px)"
            : "20px"
          : "8px",
      }}
    >
      {children}
    </div>
  );
}
